module.exports = __webpack_public_path__ + "static/img/r_019.12ce8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_019.jpg
// module id = suTd
// module chunks = 1